import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconHelpSvg } from "./IconHelpSvg.mjs";
const IconHelp = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconHelpSvg, ...iconProps });
};
export {
  IconHelp
};
